import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-cash-flow',
    templateUrl: './cash-flow.component.html',
    styleUrls: ['./cash-flow.component.scss'],
    standalone: false
})
export class CashFlowComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
